import {Component} from "../interface/component";
import {inject, injectable} from "inversify";
import SERVICE_IDENTIFIER from "../container/identifiers";
import {ModalService} from "../service/modal";
import * as tinymce from "tinymce";

@injectable()
export class CourseFormComponent implements Component {

    private $root:JQuery;
    private $details:JQuery;
    private $shoudUseBooking:JQuery;
    private $type:JQuery;

    private $bookingElements:JQuery;
    private $typeElements:JQuery;

    @inject(SERVICE_IDENTIFIER.MODAL) public modalService: ModalService;

    init(elem:HTMLElement) {
        this.$root = $(elem);

        this.$shoudUseBooking = this.$root.find('.js-course-form__use-booking');
        this.$type = this.$root.find('.js-course-form__type');
        this.$details = this.$root.find('.js-course-form__details');

        this.$bookingElements = this.$root.find('.js-course-form__external-bookings,.js-course-form__curatorspace-bookings');
        this.$typeElements = this.$root.find('.js-course-form__for-courses,.js-course-form__for-products,.js-course-form__for-prerecorded');

        this.bindUI();
    }

    private bindUI() {
        this.$shoudUseBooking.on({ change: this.handleBookingChange });
        this.$type.on({ change: this.handleTypeChange });
        this.$root.on({ submit: this.handleSubmit });
        this.handleBookingChange();
        this.handleTypeChange();
    }

    private handleBookingChange = () => {
        this.$bookingElements.hide();
        this.$bookingElements.each((index, element) => {
            if (this.shouldShow(element))
                $(element).show()
        });
    }

    private handleTypeChange = () => {
        this.$typeElements.hide();
        this.$typeElements.each((index, element) => {
            if (this.shouldShow(element))
                $(element).show()
        });
    }

    private shouldShow(element:HTMLElement): boolean {
        let $element = $(element);

        let classes = $element.attr('class').split(" ");
        switch (this.$type.val()) {
            case 'prerecorded':
                if (-1 === classes.indexOf('js-course-form__for-prerecorded')) {
                    return false;
                }
                break;
            case 'kit':
                if (-1 === classes.indexOf('js-course-form__for-products')) {
                    return false;
                }
                break;
            case 'course':
                if (-1 === classes.indexOf('js-course-form__for-courses')) {
                    return false;
                }
                break;
        }

        switch (this.$shoudUseBooking.val()) {
            case 'yes':
                if ($element.hasClass('js-course-form__external-bookings')) {
                    return false;
                }
                break;
            case 'no':
                if ($element.hasClass('js-course-form__curatorspace-bookings')) {
                    return false;
                }
                break;
            default:
                return false;
        }
        return true;
    }

    private handleSubmit = (ev:any) => {
        ev.preventDefault();
        this.$root.find(':input').addClass('disabled');
        (<HTMLFormElement>this.$root.get(0)).submit();
    }
}